module.exports = __webpack_public_path__ + "static/media/autMenoresDesafio.475caf62.pdf";